import BatteryChargingFullIcon from "@mui/icons-material/BatteryChargingFull";
import BoltIcon from "@mui/icons-material/Bolt";
import FlipCameraAndroidIcon from "@mui/icons-material/FlipCameraAndroid";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import RvHookupIcon from "@mui/icons-material/RvHookup";
import SpeedIcon from "@mui/icons-material/Speed";
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import PowerIcon from '@mui/icons-material/Power';
import ElectricRickshawIcon from '@mui/icons-material/ElectricRickshaw';
import LowPriorityIcon from '@mui/icons-material/LowPriority';
import AirlineSeatLegroomExtraIcon from '@mui/icons-material/AirlineSeatLegroomExtra';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import CategoryIcon from '@mui/icons-material/Category';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';

export const keySpecificationsInfo = {
  treoZor: [
    {
      icon: <BoltIcon />,
      info: `Powerful <span style=font-weight:900;>8KW Motor</span> for Efficient Transportation`,
    },
    {
      icon: <BatteryChargingFullIcon />,
      info: "Modern <span style=font-weight:900;>7.37 kWh Lithium-Ion Battery</span> for Longer-Lasting Power",
    },
    {
      icon: <SpeedIcon />,
      info: "Range of  <span style=font-weight:900;>80 kms/Charge</span> for Extended Travel",
    },
    {
      icon: <FlipCameraAndroidIcon />,
      info: "High torque of  <span style=font-weight:900;>42Nm</span> for Handling Heavy Cargo",
    },
    {
      icon: <LocalShippingIcon />,
      info: "Spacious Cargo Deck with  <span style=font-weight:900;>550 kgs Load capacity</span> for Transporting Heavy Loads",
    },
    {
      icon: <RvHookupIcon />,
      info: " <span style=font-weight:900;>BOOST Mode </span>for Extra power on Up-Hill, Flyovers and Steep Roads.",
    },
  ],

  zorGrand: [
    {
      icon: <BoltIcon />,
      info: `Best In Industry <span style=font-weight:900;>12 kW Motor</span> for Unmatched Efficiency
`,
    },
    {
      icon: <BatteryChargingFullIcon />,
      info: "Safe & Powerful <span style=font-weight:900;>10.24 kWh Battery with 5 years Warranty</span>",
    },
    {
      icon: <SpeedIcon />,
      info: "Travel Range of <span style=font-weight:900;>85 kms/Charge</span> for Uninterrupted Long Travel",
    },
    {
      icon: <FlipCameraAndroidIcon />,
      info: "Excellent Torque of <span style=font-weight:900;>50 Nm</span> for Handling Heavy Cargo",
    },
    {
      icon: <LocalShippingIcon />,
      info: "Large Cargo Deck with <span style=font-weight:900;>550 kgs Load capacity</span> for Transporting Heavy Loads",
    },
    {
      icon: <RvHookupIcon />,
      info: "Effortless <span style=font-weight:900;>Clutch free and Gearless Drive </span>for Smooth and Fatigue-Free Ride",
    },
  ],
  piaggioFX: [
    {
      icon: <BoltIcon />,
      info: `Easily navigate tight spaces and carry heavy loads with <span style=font-weight:900;>45 Nm of torque</span>.`,
    },
    {
      icon: <BatteryChargingFullIcon />,
      info: "Go up to <span style=font-weight:900;>80 km </span>on a single charge, perfect for urban and suburban businesses.",
    },
    {
      icon: <SpeedIcon />,
      info: "Keep your vehicle running all day long with a powerful Li-ion battery of <span style=font-weight:900;>8 kWh</span> capacity and <span style=font-weight:900;>charging time</span> of just 3 hours 30 minutes.",
    },
    {
      icon: <FlipCameraAndroidIcon />,
      info: "<span style=font-weight:900;>Reliable and durable</span> vehicle that can withstand the rigors of everyday use and easily handle heavy loads with an <span style=font-weight:900;>8 kW</span> motor.",
    },
    {
      icon: <LocalShippingIcon />,
      info: "<span style=font-weight:900;>Best in industry latest features</span> - Hill-hold Assist, Easy Home Charging and Enhanced pickup with Boost Mode.",
    },
    {
      icon: <RvHookupIcon />,
      info: "Trust of Ape assures a superior range with <span style=font-weight:900;> 35% </span>higher range.",
    },
  ],
  piaggioFXMax: [
    {
      icon: <BoltIcon />,
      info: `With a torque of <span style=font-weight:900;>45 Nm</span> and a powerful <span style=font-weight:900;>9.55 kW</span> motor, this electric cargo auto ensures efficient and robust performance.`,
    },
    {
      icon: <BatteryChargingFullIcon />,
      info: "The vehicle offers an impressive range of <span style=font-weight:900;>90 km</span> per charge, making it perfect for both urban and suburban deliveries.",
    },
    {
      icon: <SpeedIcon />,
      info: "Recharge the lithium-ion battery in just <span style=font-weight:900;>3 hours and 45 minutes</span>, minimizing downtime and maximizing productivity.",
    },
    {
      icon: <FlipCameraAndroidIcon />,
      info: " Boasting a substantial loading capacity of <span style=font-weight:900;>550 kgs</span> that can handle all your delivery needs.",
    },
    {
      icon: <LocalShippingIcon />,
      info: "Equipped with an <span style=font-weight:900;>8 kWh </span>battery, this auto ensures consistent and reliable power delivery.",
    },
    {
      icon: <RvHookupIcon />,
      info: "Cruise at a top speed of <span style=font-weight:900;>50 km/hour</span>, ensuring timely deliveries.",
    },
  ],

  greavesEltra: [
    {
      icon: <BoltIcon />,
      info: ` <span style=font-weight:900;>Charging Time:</span> Experience quick turnarounds with just 5-6  hours required to fully charge the Greaves Eltra electric truck.`,
    },
    {
      icon: <BatteryChargingFullIcon />,
      info: `<span style=font-weight:900;>Motor Power:</span> With a robust 9.5 kW motor, this electric loading auto handles heavy loads effortlessly.`,
    },
    {
      icon: <SpeedIcon />,
      info: `<span style=font-weight:900;>Loading Capacity: </span>The Greaves Eltra EV boasts a substantial loading capacity of 530 kg, accommodating a wide range of cargo.
`,
    },
    {
      icon: <FlipCameraAndroidIcon />,
      info: `<span style=font-weight:900;>Battery Capacity:</span> Equipped with a high-capacity 10.8 kWh lithium-ion battery, it's ready for long-distance deliveries.`,
    },
    {
      icon: <LocalShippingIcon />,
      info: `<span style=font-weight:900;>Range:</span> Cover extensive routes with an impressive range of 105 km per charge, reducing the need for frequent charging stops.
`,
    },
    {
      icon: <RvHookupIcon />,
      info: `<span style=font-weight:900;>Top Speed:</span> Navigate through city traffic swiftly with a top speed of 50 km/hour, ensuring timely deliveries.`,
    },
  ],

  touroMax: [
    {
      icon: <BoltIcon />,
      info: "<span style='font-weight:900;'>Charging Time:</span> It takes just 4 hours to fully charge the Etrio Tour Max ++.",
    },
    {
      icon: <BatteryChargingFullIcon />,
      info: "<span style='font-weight:900;'>Motor Power:</span> With a powerful 9.55 kW motor, it is capable of handling heavy loads.",
    },
    {
      icon: <SpeedIcon />,
      info: "<span style='font-weight:900;'>Loading Capacity:</span> The Etrio Tour Max ++ boasts a substantial loading capacity of 550 kg.",
    },
    {
      icon: <FlipCameraAndroidIcon />,
      info: "<span style='font-weight:900;'>Battery Capacity:</span> Equipped with a high-capacity 10.8 kWh lithium-ion battery, it can cover long distances.",
    },
    {
      icon: <LocalShippingIcon />,
      info: "<span style='font-weight:900;'>Range:</span> This EV has an impressive range of 100 km per charge, allowing for extensive deliveries.",
    },
    {
      icon: <RvHookupIcon />,
      info: "<span style='font-weight:900;'>Top Speed:</span> With a top speed of 50 km/hour, the Etrio Tour Max ++ can quickly navigate through city traffic.",
    },
  ],

  hiLoadDV: [
    {
      icon: <BoltIcon />,
      info: "<span style='font-weight:900;'>Fast Charge:</span> Charge for 15 minutes and get a range of 50 kms.",
    },
    {
      icon: <BatteryChargingFullIcon />,
      info: "<span style='font-weight:900;'>Motor Power:</span> Bigger 13 kWh motor, is one of the best in the segment.",
    },
    {
      icon: <SpeedIcon />,
      info: "<span style='font-weight:900;'>Loading Capacity:</span> Euler HiLoad electric load gadi has 688 kg load carrying capacity, again highest in the segment.",
    },
    {
      icon: <FlipCameraAndroidIcon />,
      info: "<span style='font-weight:900;'>Battery Capacity:</span> Featuring a high-capacity 13 kWh lithium-ion battery, it's ready for long-distance deliveries.",
    },
    {
      icon: <LocalShippingIcon />,
      info: "<span style='font-weight:900;'>Range:</span> Cover extensive routes with an impressive range of 130 km per charge, reducing the need for frequent charging stops.",
    },
    {
      icon: <RvHookupIcon />,
      info: "<span style='font-weight:900;'>Easy Navigation:</span> Navigate through city traffic with ease, with 88.5 Nm peak Torque.",
    },
  ],

  neev: [
    {
      icon: <BoltIcon />,
      info: "<span style='font-weight:900;'>Rapid Charging:</span> Full charge in just 3 hours 30 minutes, ensuring minimal downtime.",
    },
    {
      icon: <BatteryChargingFullIcon />,
      info: "<span style='font-weight:900;'>Motor Power:</span> Equipped with a powerful 8.25 kW motor, it stands out in its class.",
    },
    {
      icon: <SpeedIcon />,
      info: "<span style='font-weight:900;'>Loading Capacity:</span> The Altigreen neEV electric cargo vehicle boasts an impressive 550 kg load carrying capacity, setting a new standard.",
    },
    {
      icon: <FlipCameraAndroidIcon />,
      info: "<span style='font-weight:900;'>Battery Capacity:</span> Featuring a high-capacity 11 kWh lithium-ion battery, it's ready for long-distance deliveries.",
    },
    {
      icon: <LocalShippingIcon />,
      info: "<span style='font-weight:900;'>Extended Range:</span> Cover extensive routes with a remarkable range of up to 120 km per charge, reducing the need for frequent charging stops.",
    },
    {
      icon: <RvHookupIcon />,
      info: "<span style='font-weight:900;'>Effortless Maneuvering:</span> Navigate through city traffic with ease, thanks to its 45 Nm peak torque.",
    },
  ],

  montraePV: [
    {
      icon: <BatteryChargingFullIcon />,
      info: "<span style='font-weight:900;'>Access Super Range:</span> Goes up to 160 km on a single charge, perfect for urban and sub-urban regions.",
    },
    {
      icon: <PowerIcon />,
      info: "<span style='font-weight:900;'>Reliable Battery:</span> 7-point battery sensor to calculate important battery parameters.",
    },
    {
      icon: <AirlineSeatLegroomExtraIcon />,
      info: "<span style='font-weight:900;'>Comfortable Ride:</span>  Extra head and legroom for a comfortable ride for the driver and the passengers.",
    },
    {
      icon: <LowPriorityIcon />,
      info: "<span style='font-weight:900;'>Durable Build:</span>Extra safe boron steel chassis and durable metal body.",
    },
    {
      icon: <EmojiEmotionsIcon />,
      info: "<span style='font-weight:900;'>Effortless Driving:</span> Super drive modes for better efficiency and speed",
    },
    {
      icon: <ElectricRickshawIcon />,
      info: "<span style='font-weight:900;'>Powerful Motor:</span> Glides smoothly on the road with a powerful 10 kWh battery capacity.",
    },
  ],
  piaggioEcityFx: [
    {
      icon: <CurrencyRupeeIcon />,
      info: "<span style='font-weight:900;'>Low Running Cost:</span> Achieve unparalleled profits with a running cost as low as 39p/km.",
    },
    {
      icon: <ElectricRickshawIcon />,
      info: "<span style='font-weight:900;'>Seamless Maneuverability:</span> Effortlessly maneuver through busy areas, with 29 Nm of torque.",
    },
    {
      icon: <SpeedIcon />,
      info: "<span style='font-weight:900;'>Boost Mode:</span> Experience rapid acceleration with the boost mode.",
    },
    {
      icon: <CategoryIcon />,
      info: "<span style='font-weight:900;'>Iconic Design:</span> Get a stylish appearance with the Italian design aesthetic.",
    },
    {
      icon: <HealthAndSafetyIcon />,
      info: "<span style='font-weight:900;'>Safe Ride: </span>Foster safety and visibility with transparent windows on both sides, creating an open atmosphere for passengers.",
    },
    {
      icon: <WorkspacePremiumIcon />,
      info: "<span style='font-weight:900;'>Warranty Assurance:</span> Enjoy peace of mind with an industry-leading warranty covering 175,000 km.",
    },
  ],
  bajajAutoRikshaw: [
    {
      icon: <LocalShippingIcon />,
      info: "<span style='font-weight:900;'>Extended Range:</span> With a powerful battery of 8.9 kWh enjoy an extended range of 178 km.",
    },
    {
      icon: <SpeedIcon />,
      info: "<span style='font-weight:900;'>Extra Mileage:</span> 2 speed automation transition for extra mileage and earning.",
    },
    {
      icon: <BatteryChargingFullIcon />,
      info: "<span style='font-weight:900;'>Battery Warranty:</span> Enjoy peace of mind with an extended battery warranty of 60 months or 1,20,000 km.",
    },
    {
      icon: <ElectricRickshawIcon />,
      info: "<span style='font-weight:900;'>Advanced Motor:</span> Advanced PMS motor for higher range and gradability.",
    },
    {
      icon: <EmojiEmotionsIcon />,
      info: "<span style='font-weight:900;'>Comfortable Drive:</span> Enjoy a more comfortable driving experience with big tubeless radial tyres.",
    },
    {
      icon: <LowPriorityIcon />,
      info: "<span style='font-weight:900;'>Strong Chassis:</span>A strong chassis ensures long life with low maintenance",
    },
  ],
  MahindraTreoPlus: [
    {
      icon: <BatteryChargingFullIcon />,
      info: "<span style='font-weight:900;'>Impressive Range: </span>Goes up to 150 km on a single charge, perfect for urban and sub-urban regions.",
    },
    {
      icon: <LowPriorityIcon />,
      info: "<span style='font-weight:900;'>Minimal Maintenance Cost: </span>Maintenance cost is just 10p/km.",
    },
    {
      icon: <CurrencyRupeeIcon />,
      info: "<span style='font-weight:900;'>Low Running Cost: </span>Enjoy the most economical drive at just 40p/km.",
    },
    {
      icon: <BatteryChargingFullIcon />,
      info: "<span style='font-weight:900;'> Extended Warranty: </span> 3 years /80,000km standard and 2 years/ 20,000 km extended warranty.",
    },
    {
      icon: <EmojiEmotionsIcon />,
      info: "<span style='font-weight:900;'>Slope Support: </span> Hill-hold assist to make driving easier on hills.",
    },
    {
      icon: <ElectricRickshawIcon />,
      info: "<span style='font-weight:900;'>Rapid Acceleration: </span> Quick pickup with a battery capacity of 8 kW and 42 Nm torque.",
    },
  ],
  ekaK15: [
    {
      icon: <BatteryChargingFullIcon />,
      info: "<span style='font-weight:900;'>Impressive Range: </span> You can drive up to 180 km on a single charge. Perfect for a heavy load bearing vehicle.",
    },
    {
      icon: <LowPriorityIcon />,
      info: "<span style='font-weight:900;'>Charging Time: </span>Only takes 4-5 hours to fully charge. Your downtime is greatly reduced.",
    },
    {
      icon: <CurrencyRupeeIcon />,
      info: "<span style='font-weight:900;'>Load Capacity: </span>Carry up to 1500 kg on a single trip.",
    },
    {
      icon: <BatteryChargingFullIcon />,
      info: "<span style='font-weight:900;'> Wheelbase: </span> Wide wheel base of 2900 mm helps you navigate through city traffic and potholes.",
    },
    {
      icon: <EmojiEmotionsIcon />,
      info: "<span style='font-weight:900;'>Battery Capacity: </span> Get an impressive 32 KwH battery capacity. More acceleration for those heavy loads.",
    },
    {
      icon: <ElectricRickshawIcon />,
      info: "<span style='font-weight:900;'>Spacious Interiors: </span> Comfortable seating for driver plus one passenger makes it the best choice for comfort.",
    },
  ],
  stormEv: [
    {
      icon: <BatteryChargingFullIcon />,
      info: "<span style='font-weight:900;'>Impressive Range: </span> You can drive up to 140 km on a single charge. Perfect as an essential transport vehicle.",
    },
    {
      icon: <LowPriorityIcon />,
      info: "<span style='font-weight:900;'>Charging Time: </span> Only takes 4 hours in fast charging mode and 6 hours for a standard charge mode. Your vehicle is always ready to work whenever you want to.",
    },
    {
      icon: <CurrencyRupeeIcon />,
      info: "<span style='font-weight:900;'>Load Capacity: </span> Carry up to 1250 kg on a single trip.",
    },
    {
      icon: <BatteryChargingFullIcon />,
      info: "<span style='font-weight:900;'> Ground Clearance: </span>Sporting a solid 175 mm of ground clearance, Euler Storm EV helps you navigate even the toughest of terrains.",
    },
    {
      icon: <EmojiEmotionsIcon />,
      info: "<span style='font-weight:900;'>Battery Capacity: </span> Get an impressive 30 KwH battery capacity. More acceleration for those heavy loads.",
    },
    // {
    //   icon: <ElectricRickshawIcon />,
    //   info: "<span style='font-weight:900;'>Rapid Acceleration: </span> Quick pickup with a battery capacity of 8 kW and 42 Nm torque.",
    // },
  ],
};
